import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import PrivateRoute from "./Routes/PrivateRoute";

import Layout from "./Routes/Layout";
import Login from "./Identity/Login";
import Registration from "./Identity/Registration";
import Forgot from "./Identity/Forgot";
import About from './External/About';
import Contact from './External/Contact';
import PrivacyPolicy from './External/PrivacyPolicy';
import TermsofService from './External/TermsofService';
import PaymentSecurity from './External/PaymentSecurity';

function App() {
  return (
    <BrowserRouter>
      <Routes>

        {/* PUBLIC ROUTES */}
        <Route path="/login" element={<Login />} />
        <Route path="/registration" element={<Registration />} />
        <Route path="/forgot-password" element={<Forgot />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-of-service" element={<TermsofService />} />
        <Route path="/payment-security" element={<PaymentSecurity />} />


        {/* PROTECTED ROUTES */}
        <Route
          path="/*"
          element={
            <PrivateRoute>
              <Layout />
            </PrivateRoute>
          }
        />

      </Routes>
    </BrowserRouter>
  );
}

export default App;


